export const EMPLOYEE_GRADES_API_PATHS = {
  GET_EMPLOYEE_GRADES: "v1/organization/{0}/employee-grades/",
  CREATE_EMPLOYEE_GRADE: "v1/organization/{0}/employee-grade/create-or-update/",
  UPDATE_EMPLOYEE_GRADE: "v1/organization/{0}/employee-grade/create-or-update/",
  PATCH_EMPLOYEE_GRADE_STATUS: "v1/organization/{0}/employee-grade/{1}/status/",
  DELETE_EMPLOYEE_GRADE: "v1/organization/{0}/employee-grade/{1}/delete",
};
